<template>
  <div class="withdraw my_wallet">
    <div class="top-wallet">
      <div class="yu-title">提现明细</div>
      <div id="range_date" class="range-date">
        下单时间
        <el-date-picker
          class="screen range_date"
          v-model="timeSlot"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd"
          @change="getWithdrawList"
        ></el-date-picker>
      </div>
    </div>
    <div class="total-sum">
      总金额：¥{{withdraw.totalMoney}}
      <div class="daochu" @click="exportWithdrawLis()">
        <svg class="icon iconbiaodan_vedioup" aria-hidden="true">
          <use xlink:href="#iconbiaodan_vedioup" />
        </svg>
        导出
      </div>
    </div>
    <div class="withdraw-title">
      <div class="withdraw-time">提现时间</div>
      <div class="withdraw-mode">提现方式</div>
      <div class="withdraw-price">提现金额</div>
      <div class="withdraw-actual">实际到账</div>
      <div class="withdraw-servicecharge">手续费</div>
      <div class="withdraw-state">状态</div>
    </div>

    <div class="withdraw-list">
      <div class="withdraw-item" v-for="(item, index) in withdraw.rows" :key="index">
        <div class="withdraw-time">
          {{
          new Date(item.createTime).format(
          "yyyy-MM-dd HH:mm:ss"
          )
          }}
        </div>
        <div
          class="withdraw-mode"
        >{{item.targetAccount=='ALIPAY'?'支付宝账户':item.targetAccount=='WECHAT'?'微信账户':"未到账"}}</div>
        <div class="withdraw-price">¥{{item.totalAmount}}</div>
        <div class="withdraw-actual">¥{{item.actualAmount}}</div>
        <div class="withdraw-servicecharge">¥{{item.serviceCharge}}</div>
        <div class="withdraw-state">{{isStatus(item.status)}}</div>
      </div>
    </div>

    <div class="fenye">
      <el-pagination
      v-if="withdraw.total>15"
        background
        layout="prev, pager, next"
        :total="withdraw.total"
        :page-size="15"
        @current-change="pageSize"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      timeSlot: ["", ""],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      page: 1,
      withdraw: {
        rows: [],
        totalMoney: 0,
        total: 0
      },
      baseApl:process.env.VUE_APP_BASE_API
    };
  },
  mounted() {
    this.getWithdrawList();
  },

  methods: {
    // 页数
    pageSize(val) {
      this.page = val;
      this.getWithdrawList();
    },
    // 获取提现列表
    getWithdrawList() {
      this.$fetch(`/order/api/withdraw/list`, {
        startTime: this.timeSlot[0],
        endTime: this.timeSlot[1],
        pageIndex: this.page,
        pageSize: 15
      }).then(res => {
        if (res.code == 0) {
          console.log(res);
          this.withdraw = res.data;
        } else {
          this.$message(res.message);
        }
      });
    },
    // 导出体现列表
    exportWithdrawLis() {
      this.$axios({
        url: `${this.baseApl}/order/api/withdraw/export?startTime=${this.timeSlot[0]}&endTime=${this.timeSlot[1]}`,
        method: "post",
        headers: { "Content-Type": "application/json", "WEB-TOKEN": Cookies.get('token') },
        responseType: 'blob',
      }).then(res => {
         var filename = "提现明细";
          let url = window.URL.createObjectURL(res.data)
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', filename + '.xlsx')
          document.body.appendChild(link)
          link.click()
      });
    },
    // 提现状态
    isStatus(item) {
      if (item == "FALL") {
        return "提现失败";
      }
      if (item == "FINISH") {
        return "提现成功";
      }
      if (item == "CASH_OUT") {
        return "提现中";
      }
    }
  }
};
</script>
<style lang='scss' scoped>
.withdraw {
  .top-wallet {
    height: 111px;
    #range_date .range_date {
      margin-top: 0;
    }
  }
  .total-sum {
    background: #ffffff;
    color: #5e6066;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 13px 20px;
    .daochu {
      color: #909399;
      cursor: pointer;
      .iconbiaodan_vedioup {
        width: 14px;
        height: 13px;
      }
    }
  }
  .withdraw-title {
    background: #f9fafa;
    padding: 0 20px;
    height: 30px;
    display: flex;
    margin-top: 15px;
    & > div {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #5e6066;
      font-size: 12px;
    }
  }
  .withdraw-list {
    background: #ffffff;
    .withdraw-item {
      padding: 0 20px;
      display: flex;
      align-items: center;
      height: 50px;
      & > div {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #5e6066;
        font-size: 12px;
      }
    }
    .withdraw-item:nth-child(2n) {
      background: #f9fafa;
    }
  }
  .withdraw-time {
    width: 160px;
  }
  .withdraw-mode {
    width: 224px;
  }
  .withdraw-price,
  .withdraw-actual,
  .withdraw-servicecharge {
    width: 120px;
  }
  .withdraw-state {
    width: 113px;
  }
}
</style>